import React from "react";
import { Box, Typography, Avatar, Chip } from "@mui/material";
import { AppColors } from "../../../../../util/AppColors";
import { FaWhatsapp } from "react-icons/fa";

const ChatHeader = ({ activeChat }) => {
  if (!activeChat) return null;

  const displayName = activeChat.petName
    ? `${activeChat.patientName} & ${activeChat.petName}`
    : activeChat.patientName;

  const roleLabel = (activeChat.role || "").trim();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 3,
        py: 2,
        borderBottom: "1px solid #E2E8F0",
        backgroundColor: AppColors.white
      }}
    >
      {/* User / Pet Profile */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box sx={{ position: "relative" }}>
          <Avatar
            sx={{
              width: 48,
              height: 48,
              backgroundColor: "#E2F0FD",
              color: "#0054A6",
              fontSize: "16px",
              fontWeight: "700",
              fontFamily: "Montserrat"
            }}
          >
            {activeChat.avatarInitials}
          </Avatar>
          {/* Online indicator */}
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              right: activeChat.channel === "whatsapp" ? 14 : 0,
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: activeChat.isOnline !== false ? "#10C200" : "#94A3B8",
              border: `2px solid ${AppColors.white}`,
              zIndex: 1,
            }}
          />
          {activeChat.channel === "whatsapp" && (
            <Box
              sx={{
                position: "absolute",
                bottom: -2,
                right: -2,
                width: 18,
                height: 18,
                borderRadius: "50%",
                backgroundColor: "#25D366",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: `2px solid ${AppColors.white}`
              }}
            >
              <FaWhatsapp style={{ color: AppColors.white, fontSize: "11px" }} />
            </Box>
          )}
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "700",
                color: "#1E293B",
                fontFamily: "Montserrat"
              }}
            >
              {displayName}
            </Typography>
            {roleLabel ? (
              <Chip
                label={roleLabel}
                size="small"
                sx={{
                  backgroundColor: "#EAF8E6",
                  color: "#1E6B08",
                  fontSize: "11px",
                  fontWeight: "600",
                  height: "20px",
                  borderRadius: "6px",
                  fontFamily: "Montserrat",
                  "& .MuiChip-label": { px: 1 }
                }}
              />
            ) : null}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatHeader;
